// @ts-nocheck

// This file contains utility functions related to Tealium tracking and consent management.

function TealiumConsentPrivacyLink() {
  // Redirect to the privacy policy page keeping the localization
  const redirectUrl = `${Shopify.routes.root}policies/privacy-policy`;
  window.location.href = redirectUrl;
}
function TealiumTermsOfUseLink() {
  const redirectUrl = `${Shopify.routes.root}policies/terms-of-service`;
  window.location.href = redirectUrl;
}
function TealiumConsentFormLink() {
  const urls = {
    "en-CA":
      "https://e.nuanceaudio.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DBQjkPkSURQG5ubyzgzbzbsize0o7Lvzc2zdzdzf5EsFiJS1edTXb5MfnVXMtX%3DBQjkPkSURQG5rSfu2zgIUF6C4mzgEHYwrCLsFiJS1edTXb5Mfn&_ei_=EWMFHidOpVcspu3a8bfMXAY&_di_=gmj427nj3qb4fafp3eg193fmfubq4qi8mmaq8vs11mt0bo1b31i0",
    "fr-CA":
      "https://e.nuanceaudio.com/pub/sf/ResponseForm?_ri_=X0Gzc2X%3DBQjkPkSURQG5Iyglzg2bhqMJbmhog22weIzbzdzaH6pDofskDzg1OVXMtX%3DBQjkPkSURQGyibYBKYlbPJDzfRe0foYq22zbzdzaH6pDofskDzg1O&_ei_=E-qc0lDoPc4MWTUlAWGToEw&_di_=j34e453acplse7jvqc5k7rjtgum6p3cq3nfced6dcjlued5gjol0",
  };
  const key = `${Shopify.locale}-${Shopify.country}`;
  // @ts-ignore
  const redirectUrl = urls[key] || urls["en-CA"];
  window.location.href = redirectUrl;
}

// Make them globally accessible for Tealium to call
window.TealiumConsentPrivacyLink = TealiumConsentPrivacyLink;
window.TealiumTermsOfUseLink = TealiumTermsOfUseLink;
window.TealiumConsentFormLink = TealiumConsentFormLink;

function createLocalPayload(value) {
  if (Array.isArray(value)) {
    return value.map((item) => createLocalPayload(item));
  }

  if (value && typeof value === "object") {
    const localObject = {};
    for (const [key, nestedValue] of Object.entries(value)) {
      localObject[key] = createLocalPayload(nestedValue);
    }

    return localObject;
  }

  return value;
}

function pushToTealiumQueue(payload) {
  const localPayload = createLocalPayload(payload);
  console.log("Push to Tealium", localPayload);
  tealium_data2track.push(localPayload);
}

export function triggerPageView(data) {
  const payload = {
    id: "VirtualPage-View",
    ...data,
  };
  //console.log("TriggerPageView", payload);
  pushToTealiumQueue(payload);
}
export function triggerTrackEvent(data) {
  const payload = {
    id: "Event",
    ...data,
  };
  //console.log("triggerTrackEvent", payload);
  pushToTealiumQueue(payload);
}
export function triggerTrackClick(data) {
  const payload = {
    id: "Click",
    ...data,
  };
  //console.log("triggerTrackClick", payload);
  pushToTealiumQueue(payload);
}

export async function hashToSha256(message) {
  message = message.trim().toLowerCase();
  // Encode the string as a Uint8Array
  const msgBuffer = new TextEncoder().encode(message);

  // Hash the message using SHA-256
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

  // Convert the ArrayBuffer to a hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => ("00" + b.toString(16)).slice(-2))
    .join("");

  return hashHex;
}
export function hashToMd5(message) {
  message = message.trim().toLowerCase();
  // Encode the string as a Uint8Array
  const hash = CryptoJS.MD5(message).toString();
  return hash;
}
